module.exports = __webpack_public_path__ + "363d5121d5558a098de820da26d345e4.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/manage-account/owner/change/change-account-owner.html
// module id = 2077
// module chunks = 0